// extracted by mini-css-extract-plugin
export var text = "styles-module__text___VMzHY";
export var head3 = "styles-module__head3___J6ByW";